import Footer from "./footer";
import Wallet_modal from "./modal/wallet_modal";
import BidsModal from "./modal/bidsModal";
import BuyModal from "./modal/buyModal";
import BurnModal from "./modal/burnModal";
import { Hero } from "./component";
import React from "react";
import HeaderAdmin from "./header/HeaderAdmin";
import {useAuth} from "react-oidc-context";

export default function Layout({ children }) {
    const auth = useAuth();

  return (
    <>
      <HeaderAdmin />
      <Wallet_modal />
      <BidsModal />
      <BuyModal />
        <BurnModal />
      {auth.isAuthenticated && <main>{children}</main>}
      {!auth.isAuthenticated && <Hero />}
      <Footer />
    </>
  );
}